import React, { useState, useEffect, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import apiClient from "../../apiClient/apiClient";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { FETCH_SESSION_DATA, FETCH_SINGLE_USER_DATA } from "../../apiClient/apiEndpoints";
import moment from "moment";
import { convertToDateString, findViolationItems } from "../../utils/common";
import { Galleria } from "primereact/galleria";
import { CloseIcon, EnlargeIconOne, NoStatsIcon, PrevIcon } from "../../assets/Icons";
import Filter from "../common/Filter";

const generateTime = (time, zoom) => {
  let startTime = null;
  let endTime = null;
  if (time) {
    const date = moment(time);
    if (!zoom) {
      if (date.format("HH:mm") === "23:59") {
        startTime = "23:00";
        endTime = "00:00";
      } else if (date.format("mm") !== "00") {
        startTime = date.clone().startOf("hour").format("HH:mm");
        endTime = date.format("HH:mm");
      } else {
        startTime = date.clone().subtract(1, "hours").format("HH:mm");
        endTime = date.format("HH:mm");
      }
    } else {
      startTime = date.clone().subtract(10, "minutes").format("HH:mm");
      endTime = date.format("HH:mm");
    }
  }
  return { startTime, endTime };
};

const filterItems = (sourceArray, filterData) => {
  const filters = filterData.map((fltr) => fltr.value);
  const filteredArray = sourceArray.filter((item) => {
    let check = false;
    item.violation.forEach((value) => {
      if (filters.includes(value)) {
        check = true;
      }
    });
    return check;
  });
  return filteredArray;
};

const filterOptions = [
  {
    name: "Missing Accessories",
    tags: [
      { name: "Helmet", key: "violation", value: "helmet" },
      { name: "Gloves", key: "violation", value: "gloves" },
      { name: "Boots", key: "violation", value: "boots" },
      { name: "Glasses", key: "violation", value: "glasses" },
      { name: "Safety Vest", key: "violation", value: "vest" },
      { name: "Uniform", key: "violation", value: "uniform" },
    ],
  },
];

const PersonMonitoring = () => {
  const [sideDetail, setSideDetail] = useState(false);
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const { instanceId } = useParams();
  const configData = useSelector((state) => state.config);
  const navigate = useNavigate();
  const [sessionData, setSessionData] = useState([]);
  const [personData, setPersonData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [images, setImages] = useState(null);
  const galleria = useRef(null);
  const API_URL = configData?.config?.API_URL;
  const time = query.get("start");
  const zoom = query.get("zoom");
  const date = moment(time);
  const { startTime, endTime } = generateTime(date, zoom === 'true');
  const area = query.get("area");
  const model = query.get("model");
  const data = selectedCheckboxes?.length ? filterItems(personData, selectedCheckboxes) : personData;
  const galleryImages =
    selectedCheckboxes?.length === 0
      ? images
      : data.map((item) => ({
          itemImageSrc: item.data?.images[0],
          thumbnailImageSrc: item.data?.images[0],
          alt: "Violation Image",
          title: "Violation",
        }));

  const fetchPerPersonData = async () => {
    const queryParams = {
      start: time,
    };
    if (zoom === "true") {
      queryParams.timeDuration = 10;
      queryParams.timeUnit = "minutes";
    }
    const res = await apiClient.get(`${API_URL}${FETCH_SESSION_DATA}/${instanceId}`, { params: queryParams });
    const personList = [];
    res?.sessions?.forEach((item) => {
      personList.push(
        ...item.children.map((child) => ({ ...child, violation: findViolationItems(child?.data?.accessories_data) }))
      );
    });
    setSessionData(res);
    setPersonData(personList);
    const imageDataList = [];
    personList.forEach((item) => {
      imageDataList.push({
        itemImageSrc: item.data?.images[0],
        thumbnailImageSrc: item.data?.images[0],
        alt: "Violation Image",
        title: "Violation",
      });
    });
    setImages(imageDataList);
    setLoading(false);
  };

  const fetchSingleUserData = async (uuid) => {
    const res = await apiClient.get(`${API_URL}${FETCH_SINGLE_USER_DATA}/${uuid}`);
    setUserData(res);
    setSideDetail(true);
  };

  const handleClick = (uuid) => {
    fetchSingleUserData(uuid);
  };

  useEffect(() => {
    fetchPerPersonData();
  }, [instanceId, time]);

  const responsiveOptions = [
    {
      breakpoint: "1500px",
      numVisible: 5,
    },
    {
      breakpoint: "1024px",
      numVisible: 3,
    },
    {
      breakpoint: "768px",
      numVisible: 2,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
    },
  ];

  const handleBackButton = () => {
    navigate(`/monitoring/${instanceId}?area=${area}&model=${model}&date=${time}`);
  };

  const itemTemplate = (item) => {
    return <img src={item.itemImageSrc} alt={item.alt} style={{ width: "100%", display: "block" }} />;
  };

  const thumbnailTemplate = (item) => {
    return <img src={item.thumbnailImageSrc} alt={item.alt} style={{ display: "block" }} />;
  };

  return (
    <>
      <div className="container-fluid detailed-person admindashboard p-4 pt-2 bg-grey-main">
        <div className="datacardesign py-2">
          <div className="userdash">
            <div className="row w-100 h-100 justify-content-between">
              <div className="col-lg-6 d-flex align-items-center ">
                <div className="name-info">
                  <h5>Person Monitoring</h5>
                  <div className="infos">
                    <span>
                      <h6>Area Name</h6>
                      <p>{area || ""}</p>
                    </span>
                    <span>
                      <h6>Model Name</h6>
                      <p>{model || ""}</p>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="dashstatdata">
                  <div className="welcometext">
                    <p>Total Person</p>
                    <h4>{sessionData?.totalPerson}</h4>
                  </div>
                  <div className="welcometext">
                    <p>Violation</p>
                    <h4>{sessionData?.personWithViolation}</h4>
                  </div>
                  <div className="welcometext">
                    <p>Non-Violation</p>
                    <h4>{sessionData?.personWithNonviolation}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row title-here">
          <div className="col-lg-8 d-flex gap-2 align-items-center justify-content-start">
            <span className="backbtn m-0" onClick={handleBackButton}>
              {" "}
              <PrevIcon /> Back
            </span>
            <p>
              {" "}
              Showing results for{" "}
              <span>
                {" "}
                {moment(time).format("DD-MMM-YYYY")}({startTime} - {endTime}){" "}
              </span>{" "}
            </p>
          </div>
          <div className="col-lg-4 d-flex align-items-center justify-content-end">
            <Filter
              selectedCheckboxes={selectedCheckboxes}
              setSelectedCheckboxes={setSelectedCheckboxes}
              filterOptions={filterOptions}
            />
          </div>
        </div>

        <div className="detailed-list">
          <div className={sideDetail ? "list-here detailed-active" : "list-here"}>
            {!loading
              ? data?.length > 0 &&
                data?.map((item) => (
                  <div className="list-box" key={item.uuid} onClick={() => handleClick(item.uuid)}>
                    <div className="area-card">
                      <img src={item?.data?.images[0]} />
                      <span
                        className="enlarge-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          galleria.current.show();
                        }}
                      >
                        <EnlargeIconOne />
                      </span>
                    </div>
                    <div className="area-detail">
                      <p>
                        {item?.type?.toLowerCase() === "violation" || item?.type?.toLowerCase() === "nonviolation"
                          ? item?.type
                          : "Image"}
                      </p>
                      <p>{convertToDateString(item?.data?.time)}</p>
                    </div>
                  </div>
                ))
              : Array(6)
                  .fill(0)
                  .map((_, index) => (
                    <div key={index} className="list-box">
                      <div className="area-card"></div>
                      <div className="d-flex align-items-start justify-content-start flex-column p-2 ps-3 gap-1">
                        <Skeleton width="15rem" className="text-left" baseColor="#ebebeb" highlightColor="#ffffff" />
                        <Skeleton width="15rem" baseColor="#ebebeb" highlightColor="#ffffff" />
                      </div>
                    </div>
                  ))}
          </div>
          {data?.length < 1 && (
            <div className="nothing-found  mt-5 pt-5">
              <NoStatsIcon />
              <p>No Data Recorded!</p>
            </div>
          )}
          {sideDetail && (
            <div className="active-side">
              <div className="snap-here">
                <img src={userData?.image} />
                <span className="enlarge-btn" onClick={() => galleria.current.show()}>
                  <EnlargeIconOne />
                </span>
                <span className="close-btn" onClick={() => setSideDetail(false)}>
                  <CloseIcon />
                </span>
              </div>
              <div className="details-here">
                <div className="date-time">
                  <h5>Date & Time</h5>
                  <p>{userData?.date}</p>
                </div>
                <div className="violation-detail">
                  <h5>PPE Violation</h5>
                  <p>
                    Helmet <span>{userData?.violation?.includes("helmet") ? "YES" : "NO"}</span>
                  </p>
                  <p>
                    Safety Vest <span>{userData?.violation?.includes("vest") ? "YES" : "NO"}</span>
                  </p>
                  <p>
                    Gloves <span>{userData?.violation?.includes("gloves") ? "YES" : "NO"}</span>
                  </p>
                  <p>
                    Boots <span>{userData?.violation?.includes("boots") ? "YES" : "NO"}</span>
                  </p>
                  <p>
                    Glasses <span>{userData?.violation?.includes("glasses") ? "YES" : "NO"}</span>
                  </p>
                  <p>
                    Uniform <span>{userData?.violation?.includes("uniform") ? "YES" : "NO"}</span>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Galleria
        ref={galleria}
        value={galleryImages}
        responsiveOptions={responsiveOptions}
        numVisible={9}
        style={{ maxWidth: "50%" }}
        circular
        fullScreen
        showItemNavigators
        item={itemTemplate}
        thumbnail={thumbnailTemplate}
      />
    </>
  );
};

export default PersonMonitoring;
